import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dashboardActions } from '../../../actions/dashboard.action';
import { configureActions } from '../../../actions/configure.action';
import { bindActionCreators } from 'redux';
import Loading from '../../Helpers/Loading';
import helper from '../../../utils/helper';
import DashboardMobileScreen from './DashboardMobileScreen';
import { accountActions } from '../../../actions/account.action';
import mobileConfigActions from '../../../actions/mobileConfig.actions';
import moment from 'moment';

function DashboardMobile(props) {
  const [lastUpdated, setLastUpdated] = React.useState(
    moment().format('MM/DD/yyyy hh:mm:ss'),
  );
  const [isAlert, setIsAlert] = React.useState(false);
  const mobileConfigId = localStorage.getItem('mobileConfigId');
  const refreshRate = helper.getSetting('ValueRefreshRateSec');
  React.useEffect(() => {
    props.mobileConfigActions.resetStore();
    if (mobileConfigId) {
      props.mobileConfigActions.getSpecificMobileConfig(mobileConfigId);
    }
    props.dashboardActions.getMobileAlarmListByMC(mobileConfigId);
    let _intervalId = setInterval(async () => {
      await props.dashboardActions.getMobileAlarmListByMC(mobileConfigId);
      setLastUpdated(moment().format('MM/DD/yyyy hh:mm:ss'));
    }, parseInt(refreshRate.value) * 1000);
    return () => {
      clearInterval(_intervalId);
    };
  }, []);
  React.useEffect(() => {
    setIsAlert(props.mobileConfig.mobileConfig.alertsOnly);
    let _scrollTopInterval;
    if (props.mobileConfig.mobileConfig.scrollTopMin) {
      _scrollTopInterval = setInterval(
        () => scrollToTop(),
        props.mobileConfig.mobileConfig.scrollTopMin * 60000,
      );
    }
    return () => {
      if (_scrollTopInterval) {
        clearInterval(_scrollTopInterval);
      }
    };
  }, [props.mobileConfig.mobileConfig]);
  function scrollToTop() {
    window.scrollTo(0, 0);
  }
  return (
    <DashboardMobileScreen
      alarmList={props.dashboard.mAlarmList}
      onLogout={() => props.accountActions.logout()}
      lastUpdated={lastUpdated}
      isAlert={isAlert}
      isMobile={props.isMobile}
      setIsMobile={props.setIsMobile}
    />
  );
}

function mapStateToProps(state) {
  return {
    dashboard: state.dashboard,
    mobileConfig: state.mobileConfig,
    configure: state.configure,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    mobileConfigActions: bindActionCreators(
      Object.assign({}, mobileConfigActions),
      dispatch,
    ),
    dashboardActions: bindActionCreators(
      Object.assign({}, dashboardActions),
      dispatch,
    ),
    accountActions: bindActionCreators(
      Object.assign({}, accountActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardMobile);
